import Post from "../post/Post";
import "./posts.css";
import React from "react";

export default function Posts({ posts, categoriesFromDB }) {
  return (
    <div className="posts">
      {posts.map((p) => (
        <Post key={p._id} post={p} categoriesFromDB={categoriesFromDB} />
      ))}
    </div>
  );
}
